import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  Market,
  PaymentMethod,
} from '@app/model/payment-request/payment-request.dto';
import {
  ExternalOrderCreationResponse,
  KustomService,
} from '@app/service/kustom/kustom.service';
import { LoggingService } from '@app/service/logging-service/logging.service';
import { QueryParamsService } from '@app/service/query-params/query-params.service';
import {
  AtRoute,
  DeRoute,
  FiRoute,
  NoRoute,
  routeNames,
  SeRoute,
} from '@assets/val/route-constants';

@Component({
  selector: 'kustom-landing',
  templateUrl: './kustom-landing.component.html',
  styleUrls: ['../../page-shared.css'],
})
export class KustomLandingComponent implements OnInit {
  constructor(
    private queryParamsService: QueryParamsService,
    private loggingService: LoggingService,
    private kustomService: KustomService,
    private router: Router
  ) {}

  // Required variables
  orderId: string;
  merchantId: string;
  paymentMethod: string;
  confirmationUrl: string;

  isError: boolean = false;

  async ngOnInit(): Promise<void> {
    this.orderId =
      this.queryParamsService.getQueryParams().order_id ??
      this.queryParamsService.getQueryParams().orderId;
    this.merchantId =
      this.queryParamsService.getQueryParams().merchant_id ??
      this.queryParamsService.getQueryParams().merchantId;
    this.paymentMethod =
      this.queryParamsService.getQueryParams().payment_method ??
      this.queryParamsService.getQueryParams().paymentMethod;
    this.confirmationUrl =
      this.queryParamsService.getQueryParams().return_url ??
      this.queryParamsService.getQueryParams().returnUrl;

    if (!this.orderId || !this.merchantId) {
      // Displays error if missing query params. Can't do anything without params
      this.isError = true;

      this.loggingService.warn(
        `Kustom landing page was loaded with incorrect params. Params received: OrderId: ${this.orderId}, MerchantId: ${this.merchantId}, Method: ${this.paymentMethod}.`
      );

      return;
    }

    try {
      await this.kustomService
        .getOrCreateOrder(
          this.orderId,
          this.merchantId,
          this.paymentMethod,
          this.confirmationUrl
        )
        .then((kustomOrder: ExternalOrderCreationResponse) => {
          if (!kustomOrder) {
            this.isError = true;
            return;
          }

          this.handleKustomOrderResponse(kustomOrder);
        });
    } catch (error) {
      this.isError = true;
      console.log(error);
      // redirect to it, if present
      if (this.confirmationUrl) {
        document.location.href = this.confirmationUrl;
      }
    }
  }

  handleKustomOrderResponse(
    externalOrder: ExternalOrderCreationResponse
  ): void {
    let homeRoute: string;

    switch (externalOrder.market) {
      case Market.AT:
        homeRoute = AtRoute.HOME;
        break;
      case Market.DE:
        homeRoute = DeRoute.HOME;
        break;
      case Market.FI:
        homeRoute = FiRoute.HOME;
        break;
      case Market.SE:
        // TODO Add payment methods moved to BE driven here.
        if (this.paymentMethod === PaymentMethod.PAY_IN_ADVANCE) {
          homeRoute = SeRoute.HOME;
        } else {
          homeRoute = routeNames.HOME;
        }
        break;
      case Market.NO:
        homeRoute = NoRoute.HOME;
        break;
      default:
        homeRoute = routeNames.ERROR;
        break;
    }

    // Clear order and merchant id params.
    this.queryParamsService.setQueryParam('id', externalOrder.checkoutToken);

    this.router.navigate([`/${homeRoute}`], {
      queryParams: {
        id: externalOrder.checkoutToken,
      },
    });
  }
}
